// Mock data for Idesign4u Interior Design Agency

export const companyInfo = {
  name: "Idesign4u",
  tagline: "Premium Interior Designs",
  description: "Transform your space into a masterpiece of design and functionality",
  email: "hello@idesign4u.com",
  phone: "+91 40 2355 6789",
  locations: ["Dubai", "London", "New York", "India"]
};

export const stats = [
  { value: "15+", label: "Years of Excellence" },
  { value: "500+", label: "Projects Completed" },
  { value: "04", label: "Global Offices" },
  { value: "50+", label: "Design Awards" }
];

export const services = [
  {
    id: 1,
    title: "Residential Interior Design",
    description: "Creating beautiful, functional living spaces tailored to your lifestyle and preferences.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Commercial Interiors",
    description: "Designing inspiring workspaces that boost productivity and reflect your brand identity.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Office Workspace Design",
    description: "Modern office solutions that foster collaboration and employee well-being.",
    icon: "Briefcase"
  },
  {
    id: 4,
    title: "Luxury Renovations",
    description: "Premium renovation services that transform spaces into stunning masterpieces.",
    icon: "Gem"
  },
  {
    id: 5,
    title: "Space Planning",
    description: "Strategic space optimization to maximize functionality and aesthetic appeal.",
    icon: "LayoutGrid"
  }
];

export const projects = [
  {
    id: 1,
    title: "Modern Apartment",
    location: "Dubai",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=800&q=80",
    size: "3,500 sqft",
    year: "2024"
  },
  {
    id: 2,
    title: "Luxury Villa",
    location: "London",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=800&q=80",
    size: "8,200 sqft",
    year: "2024"
  },
  {
    id: 3,
    title: "Corporate Office",
    location: "New York",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1600508772927-723e3ba305c5?w=800&q=80",
    size: "12,000 sqft",
    year: "2023"
  },
  {
    id: 4,
    title: "Boutique Hotel",
    location: "Milan",
    category: "Hospitality",
    image: "https://images.unsplash.com/photo-1525896544042-354764aa27e6?w=800&q=80",
    size: "25,000 sqft",
    year: "2023"
  },
  {
    id: 5,
    title: "Designer Kitchen",
    location: "Dubai",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?w=800&q=80",
    size: "1,200 sqft",
    year: "2024"
  },
  {
    id: 6,
    title: "Executive Suite",
    location: "Mumbai",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?w=800&q=80",
    size: "4,500 sqft",
    year: "2024"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "CEO, TechVentures",
    content: "Idesign4u transformed our office space into an inspiring environment that truly reflects our innovative culture. The attention to detail and professionalism exceeded all expectations.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80"
  },
  {
    id: 2,
    name: "James Richardson",
    role: "Property Developer",
    content: "Working with Idesign4u on our luxury residential project was an absolute pleasure. Their design vision and execution were flawless, delivering results beyond our imagination.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&q=80"
  },
  {
    id: 3,
    name: "Priya Sharma",
    role: "Hotel Chain Director",
    content: "The team at Idesign4u brought a fresh perspective to our boutique hotel design. Their creativity and understanding of hospitality spaces is truly remarkable.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80"
  },
  {
    id: 4,
    name: "Michael Chen",
    role: "Finance Director",
    content: "Our new office designed by Idesign4u has significantly improved employee satisfaction and productivity. The space planning was exceptional.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80"
  }
];

export const team = [
  {
    id: 1,
    name: "Elena Rodriguez",
    role: "Founder & Creative Director",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&q=80"
  },
  {
    id: 2,
    name: "David Park",
    role: "Lead Architect",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&q=80"
  },
  {
    id: 3,
    name: "Aisha Khan",
    role: "Senior Interior Designer",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300&q=80"
  }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "Projects", path: "/projects" },
  { name: "About", path: "/about" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" }
];

export const footerLinks = {
  company: [
    { name: "About Us", path: "/about" },
    { name: "Our Team", path: "/about#team" },
    { name: "Careers", path: "/careers" },
    { name: "Contact", path: "/contact" }
  ],
  services: [
    { name: "Residential Design", path: "/services" },
    { name: "Commercial Design", path: "/services" },
    { name: "Space Planning", path: "/services" },
    { name: "Renovations", path: "/services" }
  ],
  connect: [
    { name: "LinkedIn", url: "#" },
    { name: "Instagram", url: "#" },
    { name: "Pinterest", url: "#" },
    { name: "Facebook", url: "#" }
  ]
};

export const officeLocations = [
  {
    city: "Dubai",
    address: "Level 15, Emirates Towers, Sheikh Zayed Road",
    phone: "+971 4 355 6789"
  },
  {
    city: "London",
    address: "25 Old Broad Street, EC2N 1HQ",
    phone: "+44 20 7123 4567"
  },
  {
    city: "New York",
    address: "350 Fifth Avenue, Suite 5100",
    phone: "+1 212 555 0123"
  },
  {
    city: "Hyderabad",
    address: "Plot 42, HITEC City, Madhapur",
    phone: "+91 40 2355 6789"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Sustainable Interior Design",
    excerpt: "Exploring eco-friendly materials and practices shaping modern interiors.",
    date: "2024-12-15",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=600&q=80",
    category: "Trends"
  },
  {
    id: 2,
    title: "Maximizing Small Spaces: Design Tips",
    excerpt: "Creative solutions for making compact spaces feel spacious and functional.",
    date: "2024-12-10",
    image: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=600&q=80",
    category: "Tips"
  },
  {
    id: 3,
    title: "Color Psychology in Interior Design",
    excerpt: "How colors influence mood and behavior in residential and commercial spaces.",
    date: "2024-12-05",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&q=80",
    category: "Design"
  }
];
